<template>
  <img :src="require('@/assets/images/' + imgLoc + '.png')" />
</template>

<script>
  export default {
    props: {
      imgLoc: String,
    },
  };
</script>

<style scoped>
  img {
    width: 80px;
  }
</style>
